import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaSave, } from 'react-icons/fa';
import { FaCheck, FaPlus } from 'react-icons/fa6';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoPrint } from 'react-icons/io5';
import { LuView } from 'react-icons/lu';
import { MdEdit } from 'react-icons/md';
import { RiCloseLargeFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import A1 from '../Images/logo-w.png';
import Select from 'react-select';

const Indent = () => {
    const [items, setItems] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
    const [showForm, setShowForm] = useState(false);
    const [employe, setEmploye] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [locations, setLocations] = useState([]);
    const [employee, setEmployee] = useState(false);

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userName = user ? user.Emp_Name : 'Guest';


    useEffect(() => {
        const userData = JSON.parse(sessionStorage.getItem('user'));
        if (userData) {
            setEmploye(userData);
        } else {
            console.log('No user data found in sessionStorage');
        }
    }, []);

    useEffect(() => {
        axios.get('https://erpapi.emedha.in/pages/api/api/location')
            .then((response) => {
                if (Array.isArray(response.data)) {
                    setLocations(response.data); // Set locations if it is an array
                } else {
                    console.error('Unexpected API response for locations:', response.data);
                    setLocations([]); // Fallback to an empty array if the response is not an array
                }
            })
            .catch((error) => {
                console.error('Error fetching locations:', error);
                setLocations([]); // Fallback to an empty array in case of an error
            });
    }, []);

    useEffect(() => {
        // axios.get('https://erpapi.emedha.in/pages/api/api/location')
        //     .then((response) => {
        //         setLocations(response.data);
        //     })
        //     .catch((error) => {
        //         console.error('Error fetching main groups:', error);
        //     });

        axios.get('https://erpapi.emedha.in/pages/api/api/depertament')
            .then((response) => {
                setDepartments(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/suppliers')
            .then((response) => {
                setSuppliers(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/itemsmasterform')
            .then((response) => {
                setItems(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/employeee')
            .then((response) => {
                setEmployee(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
    }, []);
    // const isApproved = employe && employe.approve_permission === 1;
    const isApproved =
        employe?.permissions?.[2000]?.sub_ids?.[2001]?.permissions?.approve_permission === 1;


    const [rows, setRows] = useState([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));

    const handleAddRow = () => {
        setRows((prevRows) => [
            ...prevRows,
            { itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' }
        ]);
    };
    // const handleItemSelects = (itemCd, index) => {
    //     const selectedItem = items.find(item => item.itemCd === Number(itemCd));
    //     if (selectedItem) {
    //         const updatedRows = [...rows];
    //         updatedRows[index] = { ...updatedRows[index], itemCd: selectedItem.itemCd, itemDesc: selectedItem.itemDesc, itemUOM: selectedItem.itemUOM };
    //         setRows(updatedRows);
    //     }
    // };

    const handleItemSelects = (selectedOption, index) => {
        const selectedItem = items.find(item => item.itemCd === selectedOption.value);
        if (selectedItem) {
            const updatedRows = [...rows];
            updatedRows[index] = {
                ...updatedRows[index],
                itemCd: selectedItem.itemCd,
                itemDesc: selectedItem.itemDesc,
                itemUOM: selectedItem.itemUOM,
            };
            setRows(updatedRows);
        }
    };

    const itemOptions = items.map((item) => ({
        value: item.itemCd,
        label: `${item.itemCd}-${item.itemDesc}`,
    }));

    const handleSupplierSelect = (Supp_id, index) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            Supp_id: Supp_id,
        };
        setRows(updatedRows);
    };

    const [indentNos, SetIndentNos] = useState('');
    const [Location_id, setLocation_id] = useState(null);
    const [filteredItems, setFilteredItems] = useState([]);
    // const handleLocationSelects = (Location_id) => {
    //     setSearchTerm(Location_id);
    //     setLocation_id(Location_id);
    //     fetchIndentDetails(Location_id);
    //     fetchIndentNos();
    // };

    const handleLocationSelect1 = (selectedLocation) => {
        setLocation_id(selectedLocation.value);
    };

    const locationOptions = Object.keys(filteredItems).map((key) => ({
        label: `${key} - ${filteredItems[key].location_desc || ''}`,
        value: key,
    }));

    // const handleIndentSelect = (selectedIndentNo) => {
    //     SetIndentNos(selectedIndentNo);
    //     if (Location_id) {
    //         fetchIndentDetails(Location_id, selectedIndentNo);
    //     }
    // };

    const handleIndentSelect = (selectedOption) => {
        SetIndentNos(selectedOption.value);
        if (Location_id) {
            fetchIndentDetails(Location_id, selectedOption.value);
        }
    };

    const options = Location_id && filteredItems[Location_id] && Array.isArray(filteredItems[Location_id].indent_nos)
        ? filteredItems[Location_id].indent_nos.map(Indent_no => ({
            value: Indent_no,
            label: Indent_no
        }))
        : [];

    const fetchIndentDetails = async (Location_id, indentNos) => {
        try {
            const response = await axios.get(`https://erpapi.emedha.in/pages/api/combined-indent/${Location_id}/${indentNos}`);
            const data = response.data.data;
            console.log(response.data)
            if (data && data.length > 0) {
                const updatedRows = [...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' }));
                data.forEach((row, index) => {
                    updatedRows[index] = {
                        itemCd: row.itemCd || '',
                        itemDesc: row.itemDesc || '',
                        itemUOM: row.itemUOM || '',
                        Req_dt: row.Req_dt ? row.Req_dt : new Date().toISOString().split('T')[0],
                        Supp_id: row.Supp_id || '',
                        Qty: row.Qty || '',
                        Remarks: row.Remarks || '',
                        Approved_qty: row.Approved_qty || '',
                        Approved_by: row.Approved_by || '',
                        Emp_Name: row.Emp_Name || '',
                        close: row.Close || ''
                    };
                });
                setRows(updatedRows);
                const uniqueData = data.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.Location_id === value.Location_id &&
                        t.Indent_no === value.Indent_no &&
                        t.itemCd === value.itemCd
                    ))
                );
                if (uniqueData.length > 0) {
                    const indentHeader = uniqueData[0];
                    setFormData({
                        Location_id: indentHeader.Location_id || '',
                        Location_Desc: indentHeader.Location_Desc || '',
                        Indent_no: indentHeader.Indent_no || '',
                        Indent_Header_Dt: indentHeader.Indent_Header_Dt ? indentHeader.Indent_Header_Dt : new Date().toISOString().split('T')[0],  // Make sure Indent_Header_Dt is set
                        Indent_Req_by: indentHeader.Indent_Req_by || '',
                        Dept_id: indentHeader.Dept_id || ''
                    });
                }
            }
        } catch (err) {
            console.error('Error fetching indent details:', err);
        }
    };


    const fetchIndentNos = async () => {
        try {
            const response = await fetch('https://erpapi.emedha.in/pages/api/sss/pur-indent');
            const data = await response.json();
            if (data && typeof data === 'object') {
                setFilteredItems(data);
            }
        } catch (error) {
            console.error('Error fetching indent numbers:', error);
        }
    };

    useEffect(() => {
        fetchIndentNos();
        fetchIndentDetails();
    }, []);


    const [isEditing, setIsEditing] = useState(false);


    const handleSave = async () => {
        const { Location_id, Indent_no, Indent_dt, Dept_id } = formData;

        // Check if required fields are present
        if (!Location_id || !Indent_no || !Dept_id || (formMode === 'create' && !user?.Emp_id)) {
            alert("Please fill all required fields, including Indent_Req_by in create mode");
            return;
        }

        let formattedDate = '';
        if (Indent_dt && !isNaN(new Date(Indent_dt).getTime())) {
            formattedDate = new Date(Indent_dt).toISOString().split('T')[0];
        } else {
            formattedDate = new Date().toISOString().split('T')[0];
        }

        // Create a FormData object for file upload if needed
        const form = new FormData();
        form.append('Location_id', Location_id);
        form.append('Indent_no', Indent_no);
        form.append('Indent_dt', formattedDate);

        // In create mode, set Indent_Req_by from user
        if (formMode === 'create') {
            form.append('Indent_Req_by', user ? user.Emp_id : '');
        } else if (formMode === 'approve') {
            // In approve mode, do not change Indent_Req_by, keep it as is
            form.append('Indent_Req_by', formData.Indent_Req_by); // retain previous value
        }

        form.append('Dept_id', Dept_id);

        // Loop through items and append their data
        rows.forEach((row, index) => {
            let reqDate = row.Req_dt || new Date().toISOString().split('T')[0];
            form.append(`items[${index}][itemCd]`, row.itemCd);
            form.append(`items[${index}][itemDesc]`, row.itemDesc);
            form.append(`items[${index}][itemUOM]`, row.itemUOM);
            form.append(`items[${index}][Req_dt]`, reqDate);
            form.append(`items[${index}][Supp_id]`, row.Supp_id);
            form.append(`items[${index}][Qty]`, row.Qty);
            form.append(`items[${index}][Remarks]`, row.Remarks);

            if (row.Approved_qty) {
                form.append(`items[${index}][Approved_qty]`, row.Approved_qty);
            }

            // Only send Approved_by during approve mode, otherwise, keep it null in create mode or edit mode
            if (formMode === 'approve') {
                form.append(`items[${index}][Approved_by]`, row.Approved_by || user.Emp_id);
            } else {
                form.append(`items[${index}][Approved_by]`, null); // In create and edit mode, it will be null
            }

            // Only send 'close' in approve mode
            if (formMode === 'approve') {
                form.append(`items[${index}][close]`, row.close);
            }
        });

        // Prepare the request data for the backend
        const requestData = {
            Location_id,
            Indent_no: Number(Indent_no),
            Indent_dt: formattedDate,
            Dept_id, // Include Dept_id
            // Only include Indent_Req_by in create mode, keep it as is in approve mode
            ...(formMode === 'create' ? { Indent_Req_by: user ? user.Emp_id : '' } : { Indent_Req_by: formData.Indent_Req_by }),
            items: rows.map((row) => ({
                itemCd: row.itemCd,
                itemDesc: row.itemDesc,
                itemUOM: row.itemUOM,
                Req_dt: row.Req_dt || new Date().toISOString().split('T')[0],
                Supp_id: row.Supp_id,
                Qty: row.Qty,
                Remarks: row.Remarks,
                ...(row.Approved_qty && { Approved_qty: row.Approved_qty }),
                ...(formMode === 'approve' ? { Approved_by: row.Approved_by || user.Emp_id } : { Approved_by: null }), // Ensure null in edit mode
                ...(formMode === 'approve' ? { close: row.close } : {}),
            }))
        };

        try {
            if (isEditing) {
                await axios.put(`https://erpapi.emedha.in/pages/api/pur-indent/${Indent_no}`, requestData);
                alert('Item updated successfully!');
                await fetchIndentNos();  // Refresh the list of indent numbers
                await fetchIndentDetails(Location_id, Indent_no);  // Refresh the indent details

            } else {
                const response = await axios.post('https://erpapi.emedha.in/pages/api/api/pur-indent', requestData);
                console.log('Response from backend:', response);
                alert('Items added successfully! Indent No: ' + Indent_no);
                window.location.reload();

            }

            await fetchIndentNos();
            await fetchIndentDetails(Location_id, Indent_no);

        } catch (error) {
            alert('Error saving items');
            console.error('Error saving items:', error);
        }
    };




    const [showSearch, setShowSearch] = useState(false);
    const [showPlusSearch, setShowPlusSearch] = useState(false);

    const handleRefresh = () => {
        SetIndentNos(null)
        setLocation_id(null);
        setFormData('');
        setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
        setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
    };

    const handleInputChange = (e, index = null) => {
        const { name, value } = e.target;
        if (name === 'Indent_Req_by') {
            setFormData((prevState) => ({
                ...prevState,
                Indent_Req_by: user ? user.Emp_id : '',
            }));
        } else if (index !== null) {
            const updatedRows = [...rows];
            updatedRows[index] = {
                ...updatedRows[index],
                [name]: value,
            };
            setRows(updatedRows);
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: value,
            }));

            if (name === 'Location_id' && value) {
                const selectedLocation = locations.find(location => location.Location_Desc === value);
                if (selectedLocation) {
                    setFormData((prevState) => ({
                        ...prevState,
                        Indent_no: selectedLocation.Location_Id,
                    }));
                }
            }
            if (name === 'Indent_Req_by' && formMode !== 'edit') {
                setFormData(prevState => ({
                    ...prevState,
                    Indent_Req_by: user ? user.Emp_id : '',
                }));
            }

            if (name === 'Approved_by' && formMode !== 'edit') {
                setFormData(prevState => ({
                    ...prevState,
                    Approved_by: user ? user.Emp_id : '',
                }));
            }
        }
    };

    const departmentOptions = departments.map(dept => ({
        value: dept.Dept_id,
        label: `${dept.Dept_name}-${dept.Dept_id}`,
    }));

    const handleSelectChange = selectedOption => {
        setFormData(prevState => ({
            ...prevState,
            Dept_id: selectedOption ? selectedOption.value : '',
        }));
    };

    const handleQtyChange = (e, index) => {
        let value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            const updatedRows = [...rows];
            updatedRows[index] = {
                ...updatedRows[index],
                Qty: value,
            };
            setRows(updatedRows);
        }
    };

    const handleApproveQtyChange = (e, index) => {
        let value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            const updatedRows = [...rows];
            updatedRows[index] = {
                ...updatedRows[index],
                Approved_qty: value,
            };
            setRows(updatedRows);
        }
    };


    const handleLocationSelect = async (selectedOption) => {
        const locationId = selectedOption ? selectedOption.value : '';
        setFormData((prevState) => ({ ...prevState, Location_id: locationId }));

        if (locationId) {
            try {
                const response = await axios.get(`https://erpapi.emedha.in/pages/api/api/generate-indent-no?Location_id=${locationId}`);
                if (response.status === 200) {
                    const newIndentNo = response.data.indent_no;
                    setFormData((prevState) => ({ ...prevState, Indent_no: newIndentNo }));
                } else {
                    console.error('Failed to generate indent number');
                }
            } catch (err) {
                console.error('Error generating indent number:', err.message);
            }
        }
    };

    // const locationOptions1 = locations.map((location) => ({
    //     value: location.Location_Id,
    //     label: `${location.Location_Desc}-${location.Location_Id}`,
    // }));

    const locationOptions1 = Array.isArray(locations)
        ? locations.map((location) => ({
            value: location.Location_Id,
            label: `${location.Location_Desc}-${location.Location_Id}`,
        }))
        : [];  // Fallback to an empty array if locations is not an array

    const handleBack = () => { navigate(-1); };

    const [formMode, setFormMode] = useState('');
    // const userPermissions = user ? {
    //     add: user.add_permission,
    //     edit: user.edit_permission,
    //     view: user.view_permission,
    //     save: user.save_permission,
    //     approve: user.approve_permission,
    //     print: user.print_permission,
    //     close: user.close_permission,
    //     clear: user.clear_screen_permission
    // } : {};
    const userPermissions = user && user.permissions && user.permissions[2000]
        ? {
            add: user.permissions[2000].sub_ids[2001]?.permissions.add_permission || 0,
            edit: user.permissions[2000].sub_ids[2001]?.permissions.edit_permission || 0,
            view: user.permissions[2000].sub_ids[2001]?.permissions.view_permission || 0,
            save: user.permissions[2000].sub_ids[2001]?.permissions.save_permission || 0,
            approve: user.permissions[2000].sub_ids[2001]?.permissions.approve_permission || 0,
            print: user.permissions[2000].sub_ids[2001]?.permissions.print_permission || 0,
            close: user.permissions[2000].sub_ids[2001]?.permissions.exit_permission || 0,
            clear: user.permissions[2000].sub_ids[2001]?.permissions.refresh_permission || 0
        }
        : {};
    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'save' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };


    const handlePrint = () => {

    };


    const iconBox = (enabled) => ({
        width: "48px",
        height: "48px",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: enabled ? "linear-gradient(135deg, #ffffff, #f1f5ff)" : "#f0f0f0",
        boxShadow: enabled ? "0 4px 10px rgba(0,0,0,0.08)" : "none",
        cursor: enabled ? "pointer" : "not-allowed",
        opacity: enabled ? 1 : 0.5,
        transition: "all 0.3s ease",
    });

    const headerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        borderRadius: "14px",
        background: "linear-gradient(135deg, #e0e7ff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    };

    const titleStyle = {
        color: "#1e3a8a",
        fontSize: "2rem",
        fontWeight: "700",
        letterSpacing: "1px",
    };

    const iconContainer = {
        display: "flex",
        gap: "14px",
        alignItems: "center",
    };


    return (
        <>


            <div style={{ margin: '0 auto', backgroundColor: '#ffffff', padding: '1rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid black', borderRadius: '10px' }}>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <img src={A1} alt="item" style={{ width: "20%" }} />
                    <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>
                        PURCHASE INDENT
                    </h1>
                    <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.add && userPermissions.add !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.add && userPermissions.add !== 0 && getButtonState('create') ? 1 : 0.5
                        }}>
                            <FaPlus size={30} onClick={() => {
                                if (userPermissions.add && userPermissions.add !== 0) {
                                    setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
                                    setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
                                    setShowForm(true);
                                    setShowSearch(false);
                                    setShowPlusSearch(true);
                                    setFormMode('create');
                                    setIsEditing(false);
                                } else {
                                    alert("You do not have permission to Add.");
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.edit && userPermissions.edit !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit') ? 1 : 0.5
                        }}>
                            <MdEdit size={30} onClick={() => {
                                if (userPermissions.edit && userPermissions.edit !== 0) {
                                    setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
                                    setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
                                    setShowForm(true);
                                    setShowSearch(true);
                                    setShowPlusSearch(false);
                                    setFormMode('edit');
                                    setIsEditing(true);
                                } else {
                                    alert("You do not have permission to edit.");
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.view && userPermissions.view !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.view && userPermissions.view !== 0 && getButtonState('view') ? 1 : 0.5
                        }}>
                            <LuView size={30} onClick={() => {
                                if (userPermissions.view && userPermissions.view !== 0) {
                                    setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
                                    setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
                                    setShowForm(true);
                                    setShowSearch(true);
                                    setShowPlusSearch(false);
                                    setFormMode('view');
                                    setIsEditing(false);
                                } else {
                                    alert("You do not have permission to view.");
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? "pointer" : "not-allowed",
                            opacity: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? 1 : 0.5
                        }}>
                            <HiOutlineRefresh size={30} onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? "pointer" : "not-allowed",
                            opacity: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? 1 : 0.5
                        }}>
                            <FaSave size={30} onClick={userPermissions.save && userPermissions.save !== 0 ? handleSave : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? "pointer" : "not-allowed",
                            opacity: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? 1 : 0.5
                        }}>
                            <FaCheck size={30} onClick={() => {
                                if (userPermissions.approve && userPermissions.approve !== 0) {
                                    setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
                                    setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
                                    setShowForm(true);
                                    setShowSearch(true);
                                    setShowPlusSearch(false);
                                    setFormMode('approve');
                                    setIsEditing(true);
                                } else {
                                    alert("You do not have permission to approve.");
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? "pointer" : "not-allowed",
                            opacity: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? 1 : 0.5
                        }} title='Print'>
                            <IoPrint size={30} onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                            opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                        }} title='Exit'>
                            <RiCloseLargeFill size={30} onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null} />
                        </div>
                    </div>
                </div> */}

                <div style={headerStyle}>

                    {/* Logo */}
                    <img src={A1} alt="purchase-indent" style={{ width: "270px", borderRadius: "10px" }} />

                    {/* Title */}
                    <h1 style={titleStyle}>PURCHASE INDENT</h1>

                    {/* Actions */}
                    <div style={iconContainer}>

                        {/* Add */}
                        <div style={iconBox(userPermissions.add && userPermissions.add !== 0 && getButtonState('create'))}>
                            <FaPlus size={20} color="#2563eb"
                                onClick={() => {
                                    if (userPermissions.add && userPermissions.add !== 0) {
                                        setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
                                        setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
                                        setShowForm(true);
                                        setShowSearch(false);
                                        setShowPlusSearch(true);
                                        setFormMode('create');
                                        setIsEditing(false);
                                    } else {
                                        alert("You do not have permission to Add.");
                                    }
                                }}
                            />
                        </div>

                        {/* Edit */}
                        <div style={iconBox(userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit'))}>
                            <MdEdit size={20} color="#f59e0b"
                                onClick={() => {
                                    if (userPermissions.edit && userPermissions.edit !== 0) {
                                        setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
                                        setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
                                        setShowForm(true);
                                        setShowSearch(true);
                                        setShowPlusSearch(false);
                                        setFormMode('edit');
                                        setIsEditing(true);
                                    } else {
                                        alert("You do not have permission to edit.");
                                    }
                                }}
                            />
                        </div>

                        {/* View */}
                        <div style={iconBox(userPermissions.view && userPermissions.view !== 0 && getButtonState('view'))}>
                            <LuView size={20} color="#10b981"
                                onClick={() => {
                                    if (userPermissions.view && userPermissions.view !== 0) {
                                        setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
                                        setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
                                        setShowForm(true);
                                        setShowSearch(true);
                                        setShowPlusSearch(false);
                                        setFormMode('view');
                                        setIsEditing(false);
                                    } else {
                                        alert("You do not have permission to view.");
                                    }
                                }}
                            />
                        </div>

                        {/* Refresh */}
                        <div style={iconBox(userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear'))}>
                            <HiOutlineRefresh size={20} color="#6366f1"
                                onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null}
                            />
                        </div>

                        {/* Save */}
                        <div style={iconBox(userPermissions.save && userPermissions.save !== 0 && getButtonState('save'))}>
                            <FaSave size={20} color="#22c55e"
                                onClick={userPermissions.save && userPermissions.save !== 0 ? handleSave : null}
                            />
                        </div>

                        {/* Approve */}
                        <div style={iconBox(userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve'))}>
                            <FaCheck size={20} color="#16a34a"
                                onClick={() => {
                                    if (userPermissions.approve && userPermissions.approve !== 0) {
                                        setFormData({ Location_id: '', Indent_no: '', Indent_Header_Dt: '', Indent_Req_by: '', Dept_id: '', itemCd: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' });
                                        setRows([...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' })));
                                        setShowForm(true);
                                        setShowSearch(true);
                                        setShowPlusSearch(false);
                                        setFormMode('approve');
                                        setIsEditing(true);
                                    } else {
                                        alert("You do not have permission to approve.");
                                    }
                                }}
                            />
                        </div>

                        {/* Print */}
                        <div style={iconBox(userPermissions.print && userPermissions.print !== 0 && getButtonState('print'))} title="Print">
                            <IoPrint size={20} color="#0ea5e9"
                                onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null}
                            />
                        </div>

                        {/* Close */}
                        <div style={iconBox(userPermissions.close && userPermissions.close !== 0 && getButtonState('close'))} title="Exit">
                            <RiCloseLargeFill size={20} color="#ef4444"
                                onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
                            />
                        </div>

                    </div>
                </div>
                <p>Welcome To Purchase Indent: {userName}</p>
                <hr />


                {/* Empty State UI */}
                {!showForm && (
                    <div
                        style={{
                            marginTop: "20px",
                            border: "2px dashed #cbd5e1",
                            borderRadius: "16px",
                            height: "320px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
                            boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        <div style={{ textAlign: "center", color: "#64748b" }}>

                            {/* Icon */}
                            <div
                                style={{
                                    fontSize: "48px",
                                    marginBottom: "10px",
                                    opacity: 0.6,
                                }}
                            >
                                📦
                            </div>

                            {/* Text */}
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#475569",
                                }}
                            >
                                Select an action from the header to begin
                            </h2>
                        </div>
                    </div>
                )}
                {showForm && (
                    <>
                        <div>
                            <div className='mt-5' style={{ marginBottom: '16px' }}>
                                {showPlusSearch && (
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '52px', color: 'darkblue' }}>Location:</label>
                                            <Select
                                                key={formData.Location_id}
                                                options={locationOptions1}
                                                value={locationOptions1.find(option => option.value === formData.Location_id)}
                                                onChange={handleLocationSelect}
                                                placeholder="Select"

                                                styles={{
                                                    container: (provided) => ({ ...provided, width: '20%', }),
                                                    menuPortal: (provided) => ({ ...provided, zIndex: 9999, }),
                                                    menu: (provided) => ({ ...provided, width: '80%', overflowY: 'auto', }),
                                                    control: (provided) => ({ ...provided, backgroundColor: "transparent", height: '35px', padding: '4px', }),
                                                    singleValue: (provided) => ({ ...provided, color: 'black', }),
                                                }}
                                            />
                                        </div>
                                        <div className='mt-2 mb-2' style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '41px', color: 'darkblue' }}>Indent No: </label>
                                            <input type="number" name="Indent_no" value={formData.Indent_no || ''} onChange={handleInputChange} style={{ display: 'none', border: 'none', borderLeft: '2px solid #D1D5DB', padding: '12px', margin: '4px 0', width: '20%', outline: 'none', backgroundColor: 'transparent' }} readOnly />
                                        </div>
                                    </>
                                )}
                                {showSearch && (
                                    <div>
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <label style={{ marginRight: '52px', color: 'darkblue' }}>Location:</label>
                                                <Select
                                                    //  key={Location_id } 
                                                    options={locationOptions}
                                                    onChange={handleLocationSelect1}
                                                    placeholder="Search or Select Location"
                                                    isSearchable
                                                    styles={{
                                                        container: (provided) => ({ ...provided, width: '20%', }),
                                                        menuPortal: (provided) => ({ ...provided, zIndex: 9999, }),
                                                        menu: (provided) => ({ ...provided, width: '80%', overflowY: 'auto', }),
                                                        control: (provided) => ({ ...provided, backgroundColor: "transparent", height: '35px', padding: '4px', }),
                                                        singleValue: (provided) => ({ ...provided, color: 'black', }),
                                                    }}
                                                />
                                            </div>

                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <label style={{ marginRight: '41px', color: 'darkblue' }}>Indent No:</label>
                                                <Select
                                                    //key={indentNos}
                                                    options={options}
                                                    onChange={handleIndentSelect}
                                                    placeholder="Select Indent No"
                                                    styles={{
                                                        container: (provided) => ({ ...provided, width: '20%', }),
                                                        menuPortal: (provided) => ({ ...provided, zIndex: 9999, }),
                                                        menu: (provided) => ({ ...provided, width: '80%', overflowY: 'auto', }),
                                                        control: (provided) => ({ ...provided, backgroundColor: "transparent", height: '35px', padding: '4px', }),
                                                        singleValue: (provided) => ({ ...provided, color: 'black', }),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '14px', color: 'darkblue' }}>Indent Req By:</label>
                                    <input name="Indent_Req_by"
                                        key={formData.Indent_Req_by}
                                        value={formMode === 'view'
                                            ? (employee.find(emp => emp.Emp_id === formData.Indent_Req_by)?.Emp_Name || '')
                                            : formMode === 'edit' || formMode === 'approve'
                                                ? (employee.find(emp => emp.Emp_id === formData.Indent_Req_by)?.Emp_Name || '')
                                                : (user ? user.Emp_Name : '')
                                        }
                                        onChange={handleInputChange} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', margin: '4px 0', width: '20%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '32px', color: 'darkblue' }}>Department</label>
                                    <Select
                                        name="Dept_id"
                                        value={departmentOptions.find(option => option.value === formData.Dept_id) || null}
                                        onChange={handleSelectChange}
                                        options={departmentOptions}
                                        isDisabled={formMode === 'view'}
                                        styles={{
                                            container: (provided) => ({ ...provided, width: '20%', }),
                                            menuPortal: (provided) => ({ ...provided, zIndex: 9999, }),
                                            menu: (provided) => ({ ...provided, width: '80%', overflowY: 'auto', }),
                                            control: (provided) => ({ ...provided, backgroundColor: "transparent", height: '35px', padding: '4px', }), singleValue: (provided) => ({ ...provided, color: 'black', }),
                                        }}

                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '30px', color: 'darkblue' }}>Indent Date:</label>
                                    <input
                                        type="date"
                                        name={formMode === 'create' ? 'Indent_dt' : 'Indent_Header_Dt'}
                                        value={formMode === 'create'
                                            ? new Date().toISOString().split('T')[0]
                                            : (formData.Indent_Header_Dt
                                                ? new Date(formData.Indent_Header_Dt).toLocaleDateString('en-CA')
                                                : new Date().toISOString().split('T')[0]
                                            )}
                                        onChange={handleInputChange}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', margin: '4px 0', width: '20%', outline: 'none', backgroundColor: 'transparent' }}
                                        disabled={formMode === 'view' || formMode === 'approve'}
                                    />
                                </div>
                            </div>

                            <div style={{ overflowY: 'auto', maxHeight: '300px' }}>
                                <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Sl No.</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Code</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Description</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>UOM</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Req. Dt.</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Supplier Name</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Supplier ID</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Indent Qty</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Remarks</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Approved Qty</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Approved by</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Short close</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black' }}>{index + 1}</td>
                                                <td style={{ border: '1px solid black', width: '10%' }}>
                                                    <Select
                                                        options={itemOptions}
                                                        value={itemOptions.find(option => option.value === rows[index]?.itemCd)}
                                                        onChange={(selectedOption) => handleItemSelects(selectedOption, index)}
                                                        onBlur={() => { row.showSelect = false; }}
                                                        isDisabled={formMode === 'view'}
                                                        placeholder="Select Item"
                                                        styles={{
                                                            container: (provided) => ({ ...provided, width: '100%', }),
                                                            control: (provided) => ({ ...provided, border: '2px solid #D1D5DB', backgroundColor: 'transparent', height: '40px', }),
                                                            menu: (provided) => ({ ...provided, width: '280px', overflowY: 'auto', }),
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ border: '1px solid black' }}><input type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} value={row.itemDesc || ''} onChange={(e) => handleInputChange(e, index)} readOnly disabled={formMode === 'view'} /></td>
                                                <td style={{ border: '1px solid black' }}><input type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} value={row.itemUOM || ''} onChange={(e) => handleInputChange(e, index)} readOnly disabled={formMode === 'view'} /></td>
                                                <td style={{ border: '1px solid black' }}><input type="date" style={{ width: '100%', border: 'black', outline: 'black', backgroundColor: 'transparent' }} name="Req_dt" value={row.Req_dt ? new Date(row.Req_dt).toLocaleDateString('en-CA') : new Date().toISOString().split('T')[0]} onChange={(e) => handleInputChange(e, index)} disabled={formMode === 'view'} /></td>
                                                <td style={{ border: '1px solid black', width: '10%' }}>
                                                    <Select
                                                        onBlur={() => { row.showSelect = false; }}
                                                        styles={{
                                                            container: (provided) => ({ ...provided, width: '100%', }),
                                                            control: (provided) => ({ ...provided, border: '2px solid #D1D5DB', backgroundColor: 'transparent', height: '40px', }),
                                                            menu: (provided) => ({ ...provided, width: '290px', overflowY: 'auto', }),
                                                        }}
                                                        value={
                                                            suppliers.find(supplier => supplier.Supp_cd === row.Supp_id)
                                                                ? {
                                                                    value: row.Supp_id,
                                                                    label: `${suppliers.find(supplier => supplier.Supp_cd === row.Supp_id).Supp_Nm} - ${row.Supp_id}`
                                                                }
                                                                : null
                                                        } onChange={(selectedOption) => { handleSupplierSelect(selectedOption.value, index); }} isDisabled={formMode === 'view'} placeholder="Select Item" options={suppliers.map(supplier => ({ value: supplier.Supp_cd, label: `${supplier.Supp_Nm} - ${supplier.Supp_cd}`, }))} onFocus={() => console.log('Options:', suppliers)} />
                                                </td>
                                                <td style={{ border: '1px solid black', width: '8%' }}><input type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} value={row.Supp_id || ''} onChange={(e) => handleInputChange(e, index)} readOnly disabled={formMode === 'view'} /></td>
                                                <td style={{ border: '1px solid black' }}><input name="Qty" value={row.Qty || ''} onChange={(e) => handleQtyChange(e, index)} autoComplete="off"
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    spellCheck="false" type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} disabled={formMode === 'view'} /></td>
                                                <td style={{ border: '1px solid black' }}><input name="Remarks" value={row.Remarks || ''} onChange={(e) => handleInputChange(e, index)} type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} autoComplete="off"
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    spellCheck="false" disabled={formMode === 'view'} /></td>
                                                <td style={{ border: '1px solid black', width: '8%' }}><input name="Approved_qty" value={row.Approved_qty || ''} onChange={(e) => handleApproveQtyChange(e, index)} type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} disabled={formMode === 'view' || formMode === 'create' || formMode === 'edit' || !isApproved} /></td>
                                                <td style={{ border: '1px solid black', width: '8%' }}>
                                                    {formMode === 'view' ? (
                                                        <input name="Emp_Name" value={row.Emp_Name ? row.Emp_Name : ''} type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', color: row.Emp_Name ? 'black' : 'red', }} disabled />
                                                    ) : formMode === 'approve' ? (
                                                        <input name="Approved_by" value={row.Approved_by ? `${row.Emp_Name} (Approved)` : userName || ''} type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} onChange={(e) => handleInputChange(e, index)} disabled={row.Approved_by} />
                                                    ) : formMode === 'create' ? (
                                                        <input name="Approved_by" value={'NULL'} type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} disabled />
                                                    ) : (
                                                        <input name="Emp_Name" value={row.Emp_Name || ''} onChange={(e) => handleInputChange(e, index)} type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} disabled />
                                                    )}
                                                </td>
                                                <td style={{ border: '1px solid black' }}><select name="close" value={row.close || ''} onChange={(e) => handleInputChange(e, index)} style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }} disabled={formMode === 'view' || formMode === 'create' || formMode === 'edit' || !isApproved} >
                                                    <option value="Select">Select</option>
                                                    <option value="Y">Y</option>
                                                    <option value="N">N</option>
                                                </select>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="12" style={{ textAlign: 'end', border: '1px solid black' }}><button onClick={handleAddRow} style={{ padding: '5px 10px', border: '1px solid #D1D5DB', backgroundColor: 'transparent' }}><FaPlus /> Add Row</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Indent;

